import { Component, input } from '@angular/core';

export interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq',
  standalone: false,
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  /**
   * The title of the FAQ section
   */
  title = input<string>('home.faq.title');

  /**
   * The eyebrow text above the title
   */
  eyebrow = input<string>('home.faq.eyebrow');

  /**
   * The description text below the title
   */
  description = input<string>('home.faq.description');

  /**
   * The button text
   */
  buttonText = input<string>('home.faq.button');

  /**
   * Array of FAQ items
   */
  faqItems = input<FaqItem[]>([]);

  /**
   * Event handler for button click
   */
  onButtonClick = input<() => void>(() => {});

  /**
   * Track which FAQ items are expanded (multiple can be open at once)
   */
  expandedIndices: Set<number> = new Set();

  /**
   * Toggle FAQ item expansion
   */
  toggleFaq(index: number): void {
    const newSet = new Set(this.expandedIndices);
    if (newSet.has(index)) {
      newSet.delete(index);
    } else {
      newSet.add(index);
    }
    this.expandedIndices = newSet;
  }

  /**
   * Check if FAQ item is expanded
   */
  isExpanded(index: number): boolean {
    return this.expandedIndices.has(index);
  }
}
